<div class="no-print" disableContextMenu>
<pdf-viewer [src]="pdfSrc"
              [render-text]="true"
              [original-size]="false"
              [fit-to-page]="true"
              style="width:130vh; height: 90vh" 
              [external-link-target]="'blank'"
              [autoresize]="true"
              [zoom-scale]="'page-width'"
              [zoom]="zoom_scale"
              [render-text-mode]="0"
              [show-borders]="true"
              [rotation]="Rotate"
  ></pdf-viewer>
  
  
  </div>
 
  <button type="button" class="btn btn-sm" (click)="zoom(0)">-</button>zoom
  <button type="button" class="btn btn-sm" (click)="zoom(1)">+</button>
  <button type="button" class="btn btn-sm" (click)="Rotation()">Rotate</button> 
 